import { createSlice } from "@reduxjs/toolkit";
import { format, subDays } from "date-fns";
import { FilterStateBalanceReport } from "./types";

const previousDay = () => format(subDays(new Date(), 1), "yyyy-MM-dd");

const INITIAL_STATE: FilterStateBalanceReport = {
  filters: {
    periodStart: previousDay(),
    periodEnd: previousDay(),
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

const filterSlice = createSlice({
  name: "filterBalanceReport",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action) {
      state.filters[action.payload.key] = action.payload.value;
    },
  },
});

export const { setFilter } = filterSlice.actions;
export default filterSlice.reducer;
